module["exports"] = ["#{Name.last_name} #{suffix}", "#{Name.last_name} et #{Name.last_name}"];